import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';

@Component({
    selector: '',
    template: ` <dx-load-panel
    id="id"
    [delay]="delay"
    [showIndicator]="showIndicator"
    [showPane]="showPane"
    [height]="height"
    [width]="width"
    [class]="class"
    [focusStateEnabled]="focusStateEnabled"
    [hoverStateEnabled]="hoverStateEnabled"
    [message]="message"
    [minHeight]="minHeight"
    [maxHeight]="maxHeight"
    [maxWidth]="maxWidth"
    [minWidth]="minWidth"
    [shading]="shading"
    [shadingColor]="shadingColor"
    [rtlEnabled]="rtlEnabled"
    [visible]="visible"
    [position]="position"
  >
  </dx-load-panel>`,
    standalone: false
})
export class DevExLoaderComponent implements AfterViewInit {
  @Input() id: string;
  @Input() delay: string;
  @Input() showIndicator: boolean = true;
  @Input() showPane: boolean;
  @Input() height: string;
  @Input() width: string;
  @Input() show: boolean = false;
  @Input() class: string;
  @Input() text: string;
  @Input() rtlEnabled: boolean;
  @Input() visible: boolean = true;
  @Input() color: string;
  @Input() focusStateEnabled: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() message: string;
  @Input() minHeight: number;
  @Input() maxHeight: number;
  @Input() maxWidth: number;
  @Input() minWidth: number;
  @Input() shading: boolean = false;
  @Input() shadingColor: string;
  @Input() position: string = 'center';

  @ViewChild('dxLoader', { static: true }) dxLoader;

  constructor() {}
  ngAfterViewInit(): void {}
}
